import { NEW_PROTOTYPE_TEMPLATE_OPTIONS } from "./templates/NewPrototypeTemplates";

const ALL_AUDIENCES = ["fresher", "experienced"];
function withAudience(template, audience = ALL_AUDIENCES) {
  return {
    premium: false,
    ...template,
    audience,
  };
}

const BASE_TEMPLATE_OPTIONS = [
  withAudience({
    id: "template12",
    name: "Nordic Minimal",
    preview: null,
    description: "Clean single-column ATS layout with blue section rules and restrained typography.",
  }),
  withAudience({
    id: "template13",
    name: "Academic Line",
    preview: null,
    description: "Formal academic-style resume with serif heading, clean border frame, and readable section flow.",
  }),
  withAudience({
    id: "template15",
    name: "Executive Orbit Pro",
    preview: null,
    description: "Premium executive layout with selected work cards, compact profile, and polished spacing.",
  }, ["experienced"]),
  withAudience({
    id: "template7",
    name: "Mint Compact CV",
    preview: null,
    description: "Light blue compact CV with top skill bands, balanced spacing, and clean print flow.",
  }, ["experienced"]),
  ...NEW_PROTOTYPE_TEMPLATE_OPTIONS.map((template) =>
    withAudience(template),
  ),
];

export const TEMPLATE_OPTIONS = BASE_TEMPLATE_OPTIONS;

function isSelectableTemplate(template) {
  return Array.isArray(template.audience)
    ? template.audience.some((audience) => ALL_AUDIENCES.includes(audience))
    : false;
}

export function normalizeExperienceLevel(value) {
  const normalizedValue = String(value || "").trim().toLowerCase();

  if (normalizedValue === "fresher") return "fresher";
  if (
    normalizedValue === "experience" ||
    normalizedValue === "experienced"
  ) {
    return "experienced";
  }

  return null;
}

export function getTemplateOptionsForExperienceLevel(
  _experienceLevel,
) {
  return TEMPLATE_OPTIONS.filter(isSelectableTemplate);
}

export function getTemplateOptionById(templateId) {
  return (
    TEMPLATE_OPTIONS.find((template) => template.id === templateId) ||
    TEMPLATE_OPTIONS[0]
  );
}
